import { CHART_TYPE, DEFAULT_COLOR, DATA_VISUALIZATION_HUE, DATA_VISUALIZATION_HUE_VARIANT, DATA_VISUALIZATION_DEFAULTS } from '../constants';
import { getDataVisualizationColors, getLegendLabels, getLegendLabelValues, getCssColorCode } from '../utils';

import { IChart, IChartColor, IChartLegend, IChartSeries, IChartTitle, IChartData, IChartTooltip } from './interfaces';

export class BaseChart implements IChart {
  public type!: CHART_TYPE;
  public title?: IChartTitle;
  public subTitle?: IChartTitle;
  public series!: IChartSeries[];
  public color!: IChartColor;
  public legend?: IChartLegend;
  public tooltip?: IChartTooltip;
  public emptySeriesMessage?: string;
  public formatNumbers?: boolean;
  public formatCountryCode?: string;

  // To cater toggle between empty message and chart
  public get isShowChart(): boolean {
    return !!this.series?.length
  }

  // custom class level props

  // e.g: [#1234, rgba(1,2,3,.5), var(--aon-xx)]
  public computedColors!: string[];

  // e.g: ['category 1', 'category 2', 'category 3']
  public computedLengedLabels!: string[];

  // e.g: [['$123','$456', '$890'], ['20%', '30%', '50%']]
  public computedLegendValues!: string[][];

  constructor(obj: IChart) {
    Object.assign(this, obj);
    this.color = obj.color || DEFAULT_COLOR;
    this.emptySeriesMessage = obj.emptySeriesMessage || DATA_VISUALIZATION_DEFAULTS.EMPTY_SERIES_MESSAGE;
    this.formatNumbers = obj.formatNumbers ?? false

    this.computeColors();
    this.computeLegends();
  }

  // Methods

  // TODO: Revisit the access modifier. can be made private if no use case to call this on chart component;
  public computeColors(): void {
    this.computedColors = getDataVisualizationColors(this.type, this.series, this.color);
  }

  // TODO: Revisit the access modifier. can be made private if no use case to call this on chart component;
  public computeLegends(): void {
    if (this.legend) {
      this.computedLengedLabels = getLegendLabels(this.type, this.series, this.legend);
      this.computedLegendValues = getLegendLabelValues(this.type, this.series, this.legend, this.formatNumbers);
    }
  }

  //TODO: Make data parameter optional
  public getColorForDataNIndex(data: IChartData, index: number): string {
    if (data == null) return undefined;
    const priorityColor = data.color ? getCssColorCode(data.color) : undefined;
    const defaultColor = DATA_VISUALIZATION_HUE[DATA_VISUALIZATION_HUE_VARIANT.GRAY];

    return priorityColor || this.computedColors[index] || defaultColor;
  }
}